<!-- Home is the back-target for every other page; it has no back-button
     itself, and no search omnibar (nothing to search on the landing page). -->
<app-coming-soon title="Home" icon="dashboard"></app-coming-soon>
